import { useQuery } from "@apollo/client";
import { Badge, Colors } from "react-native-ui-lib";
import { QUERY_COUNT_INVOICE_ARRIVALS } from "../../modules/invoice-arrival/utils";

export const PendingInvoiceArrivalsCountChip = () => {
  const { data, loading, error } = useQuery<{
    invoiceArrivalsCount: number;
  }>(QUERY_COUNT_INVOICE_ARRIVALS, {
    fetchPolicy: "cache-and-network",
    pollInterval: 30000,
    variables: {
      options: {
        filter: {
          status: {
            in: ["PENDING"],
          },
        },
      },
    },
  });

  if (loading || error) {
    return null;
  }

  return (
    <Badge
      label={(data?.invoiceArrivalsCount ?? 0).toString()}
      labelStyle={{
        color: Colors.black,
      }}
      backgroundColor="rgb(216, 217, 219)"
    />
  );
};
